module.exports = __webpack_public_path__ + "img/yiwancheng.0642bfc4.png";